import { EmptyState } from '../../../components/common/detailListParts';
import { Section } from '../../../components/common/detailParts';
import {
  PublisherDappRow,
  sortDappsByActivity,
} from '../components/PublisherDappRow';
import type { SuperPublisherTabProps } from '../types';

export function DappsTab({ data }: SuperPublisherTabProps) {
  const { dapps, stats } = data;

  return (
    <Section
      title="Dapps"
      trailing={
        <span className="text-xs tabular-nums text-neutral-500">
          {stats.publishedDapps} live · {stats.underReviewDapps} in review ·{' '}
          {dapps.length} total
        </span>
      }
    >
      {dapps.length === 0 ? (
        <EmptyState message="This publisher has no dapps yet" />
      ) : (
        <ul className="divide-y divide-white/5">
          {sortDappsByActivity(dapps).map((dapp) => (
            <PublisherDappRow key={dapp.id} dapp={dapp} />
          ))}
        </ul>
      )}
    </Section>
  );
}
